export const environment = {
  production: false,
  // restBaseUrl: 'http://125.63.101.166:8081/bambos-rest/rest',
  // restBaseUrl: 'http://d5.iworklab.com:8081/bambos-rest/rest',
  // restBaseUrl: 'https://testbambos.soluzione1.it/bambos-rest/rest',
  // restBaseUrl: 'https://app-be.bambos.it/bambos-rest/rest/webapp',
  testBaseUrl: 'http://localhost:4200',
  restBaseUrl: 'https://testapi-focus.pianinvest.it/atrio-rest/rest/webapp',
  // restBaseUrl: 'http://localhost:8080/atrio-rest/rest/webapp',
  // basePath: 'https://testweb.spesotto.it',
  //  restBaseUrl: 'https://testapi-focus.pianinvest.it/atrio-rest/rest/webapp',
  version: '1.8.8',
  maxUploadFileSize: 3145728,
  rows: 10
};
